(ns app.domain.public-map.model
  (:require [app.domain.group.permit-type-config.model :as ptc-model]
            [clojure.set :as set]))

(def permit-types-with-public-map
  #{:permit-type/B :permit-type/BS :permit-type/PW :permit-type/PWO :permit-type/CE :permit-type/P :permit-type/LU :permit-type/SW
    :permit-type/PI})

(def general-attributes
  #{:workspace/municipal-case-id :project/name :submitted :applicants :property-owners :domain/state
    :category-names :application/work-type-names :application/work-target-names})

(def building-attributes
  (set/union general-attributes #{:completion-date :issued-date}))

(def pw-attributes
  (set/union general-attributes #{:issued-date}))

(def pwo-attributes
  (set/union general-attributes #{:workspace/case-description :created}))

(def planning-attributes
  general-attributes)

(def ce-attributes
  (set/union general-attributes #{:workspace/case-description :created}))

(def lu-attributes
  (set/union general-attributes #{:completion-date :issued-date}))

(def sw-attributes
  building-attributes)

(def pi-attributes
  #{:workspace/municipal-case-id :applicants :property-owners :domain/state :category-names})

(def public-records-tabs-in-order
  [:public-records/development
   :public-records/periodic-inspections
   :public-records/cases
   :public-records/work-orders
   :public-records/licences
   :public-records/contractor-registrations
   :public-records/complaints])

(defn public-map-attribute-tr-key [attribute]
  [attribute
   (keyword "public-map-attributes" (str (when (namespace attribute) (str (namespace attribute) "-")) (name attribute)))
   (keyword "public-map-attributes" (name attribute))])

(defn phase-states-conf [ws-state]
  (case ws-state
    :workspace.state/application :group.config/visible-application-states-in-public-map
    :workspace.state/execution :group.config/visible-execution-states-in-public-map
    :workspace.state/periodic-parent :group.config/visible-periodic-parent-states-in-public-map))

(def archived-visibility-configs
  {:application     [:group.config/visible-application-states-in-public-map :state.application/archived]
   :execution       [:group.config/visible-execution-states-in-public-map :execution.state/archived]
   :periodic-parent [:group.config/visible-periodic-parent-states-in-public-map :periodic-parent.state/archived]})

(defn archived-visibility-config [permit-type]
  (get archived-visibility-configs
       (cond
         (= permit-type :permit-type/PI) :periodic-parent
         (contains? ptc-model/execution-only-types permit-type) :execution
         :else :application)))

(def archived-visibility-states
  (set (map second (vals archived-visibility-configs))))

(def municipality-id-pattern
  #"(\w{2})-([A-Z0-9]+)$")

(def development-permit-types
  #{:permit-type/B :permit-type/BS :permit-type/P :permit-type/PW :permit-type/LU :permit-type/SW})

(def periodic-inspections-permit-types
  #{:permit-type/PI})

(def cases-permit-types
  #{:permit-type/CE})

(def work-orders-permit-types
  #{:permit-type/PWO})

(def tab->permit-types
  {:public-records/development          development-permit-types
   :public-records/periodic-inspections periodic-inspections-permit-types
   :public-records/cases                cases-permit-types
   :public-records/work-orders          work-orders-permit-types})

(defn- has-visible-categories?
  "True when at least one permit type from `pts` appears in the config map
   and has at least one category not hidden from the public map."
  [permit-type-categories-map pts]
  (let [matching (select-keys permit-type-categories-map pts)]
    (boolean
      (and (seq matching)
           (->> (vals matching)
                (mapcat :categories)
                (remove :group.config/hide-from-public-map)
                seq)))))

(defn public-records-tabs
  "Given a permit-types map of {permit-type-kw -> {:categories [...] ...}},
   returns the set of public-records tab keywords that should be shown."
  [permit-type-categories-map & {:keys [licences? contractor-registrations?]}]
  (cond-> #{}
    ;; Workspace tabs
    (has-visible-categories? permit-type-categories-map development-permit-types)
    (conj :public-records/development)

    (has-visible-categories? permit-type-categories-map periodic-inspections-permit-types)
    (conj :public-records/periodic-inspections)

    (has-visible-categories? permit-type-categories-map cases-permit-types)
    (conj :public-records/cases)

    (has-visible-categories? permit-type-categories-map work-orders-permit-types)
    (conj :public-records/work-orders)

    (some (fn [[pt config]]
            (and (ptc-model/permit-types-with-complaints pt)
                 (not (:group.config/public-map-hide-complaints config))))
          permit-type-categories-map)
    (conj :public-records/complaints)

    ;; Non-workspace tabs (licences and contractor registrations)
    licences?
    (conj :public-records/licences)

    contractor-registrations?
    (conj :public-records/contractor-registrations)))
